import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M29 13H3C2.4375 13 2 12.5625 2 12C2 11.5 2.4375 11 3 11H29C29.5 11 30 11.5 30 12C30 12.5625 29.5 13 29 13ZM29 21H3C2.4375 21 2 20.5625 2 20C2 19.5 2.4375 19 3 19H29C29.5 19 30 19.5 30 20C30 20.5625 29.5 21 29 21Z'],
  name: 'uiGripLines',
  oldName: 'falGripLines'
} as IconDefinition
